<div>
  <ng-template #contentTempl>
    <div class="loading custom-progress-bar">
      @if (uS.environment.pageLoader.isLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
    <loader [loading]="pS.isLoading()" text="Loading" [height]="screenHeight()">
      <router-outlet></router-outlet>
      <!-- <app-chat-help-desk></app-chat-help-desk> -->
    </loader>
    <div class="home-versionNo">v{{ uS.environment.versionNo }}</div>
    @if (allowProfilePreview()) {
      <user-preview-modal />
    }
    <toast-notifications [expandHandler]="toastExpandHandler()" />
  </ng-template>

  @if (userIsSuperAdmin()) {
    <ng-container *ngTemplateOutlet="contentTempl"></ng-container>
  } @else {
    <vertical-nav
      #vn
      [menuItems]="menuItems() | filterMenuArray | async"
      [isHome]="true"
      bg="transparent"
      [fixedSideNav]="true"
      [showSearch]="true"
      [showMenu]="showMenu()">
      <ng-container *ngTemplateOutlet="contentTempl"></ng-container>
      <user-helper />
    </vertical-nav>
  }
</div>
